import Component from 'generic.basecomponent';
import $ from 'jquery';

export default class PollButton extends Component {
    constructor(el) {
        super(el);
        this.setVars(el);
        this.init();
        this.inited = true;
    }

    static get componentName() {
        return 'poll-button';
    }

    setVars(el) {
        this.el = el;
        this.valueField = this.el.querySelector('[data-ref="poll-value"]');
        this.voteUrl = '/api/document/vote';
        this.isDisabled = this.el.getAttribute('disabled') === 'true';
    }

    init() {
        if (this.isDisabled) return;

        this.addEventListeners();
    }

    addEventListeners() {
        this.el.addEventListener('click', this.OnPollButtonClick.bind(this));
    }

    OnPollButtonClick() {
        if (this.isDisabled) return;

        this.isDisabled = true;

        const requestBody = {
            DocumentId: this.el.dataset.documentid,
            ContactId: this.el.dataset.contactid,
            Type: this.el.dataset.stattype
        };

        this.Vote(requestBody);
    }

    Vote(body) {
        $.ajax({
            method: 'post',
            url: this.voteUrl,
            data: body
        }).done((response) => {
            if (response.status === 'OK') {
                this.valueField.innerText = response.newValue;
                this.el.setAttribute('disabled', 'true');
                this.el.classList.remove('is-active');
            }
        }).fail((error) => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/poll-button/js/poll-button.js